import { nextTick } from '@patrianna/shared-utils'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { cancelRedeemRequest } from '@patrianna-payments/shared-store/redeem/store/actions'
import cx from 'classnames'
import { useCallback, useEffect, useState } from 'react'

import Button from 'components/Button'
import content from 'prismic-translates/transactions-history-page.json'
import { useAppDispatch } from 'store/hooks'
import type { RedeemItem, RedeemUserStatus } from 'temp/payment/client'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

const statusLabels: Partial<Record<RedeemUserStatus, string>> = {
  pending: t('pending'),
  processed: t('processed'),
  canceled: t('canceled'),
}

const TIME_TO_RETURN_LOADING_STATUS_TO_DEFAULT = 10000

export default function TransactionStatus({
  id,
  status,
  redeemStatus,
}: Pick<RedeemItem, 'id' | 'status' | 'redeemStatus'>) {
  const dispatch = useAppDispatch()
  const [isCanceling, setIsCanceling] = useState<boolean>(false)

  const onCancelRedeemRequest = useCallback(async () => {
    setIsCanceling(true)
    await dispatch(cancelRedeemRequest(id))

    void nextTick(() =>
      setTimeout(() => {
        if (isCanceling) {
          setIsCanceling(false)
        }
      }, TIME_TO_RETURN_LOADING_STATUS_TO_DEFAULT),
    )
  }, [id, isCanceling])

  useEffect(() => {
    if (status !== 'pre_authorized' && isCanceling) {
      void nextTick(() => setIsCanceling(false))
    }
  }, [isCanceling, status])

  if (status === 'pre_authorized') {
    if (isCanceling) {
      return <span className={cx(classes.status, classes.capitalize)}>{t('canceling')}</span>
    }

    return (
      <Button onClick={onCancelRedeemRequest} className={classes.button} dataTestId='transaction-item-cancel-button'>
        {t('cancel')}
      </Button>
    )
  }

  return (
    <span className={classes.status} data-testid='transaction-item-status'>
      {statusLabels[redeemStatus] || ''}
    </span>
  )
}
